var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class ExperimentResourcesBase extends RestServiceBase {
  constructor(endpoint, baseUrl) {
    if (!baseUrl) {
      baseUrl = "/api/experiments";
    }
    super(endpoint, baseUrl);
  }
  startExperiment(_0) {
    return __async(this, arguments, function* (id, registerAnalysis = false, additionalDetails = { iterateFrom: "" }) {
      const iterateFromParam = !!additionalDetails.iterateFrom ? "IterateFrom=" + additionalDetails.iterateFrom + "&" : "";
      const address = `/${id}/start?${iterateFromParam}registerAnalysis=${registerAnalysis.toString()}`;
      return yield this._post({}, address);
    });
  }
  cloneExperiment(id, additionalDetails) {
    return __async(this, null, function* () {
      const address = `/${id}/clone?template=${additionalDetails.template}&managementGroup=${additionalDetails.managementGroup}&cloneAnalysis=${additionalDetails.cloneAnalysis}`;
      return yield this._post({}, address);
    });
  }
  crossIterationResume(id, iterateFromId, registerAnalysis = false, hasRunningIteration = false, ignoreHistoricalAllocation) {
    return __async(this, null, function* () {
      let address = `/${id}/start?iterateFrom=${iterateFromId}&Comment=Cross-iteration Resume for cloned progression&OperationReason=CloneResumeProgression&skipToOriginalRunningStage=true&registerAnalysis=${registerAnalysis.toString()}`;
      if (hasRunningIteration) {
        address = `/${id}/start?iterateFrom=${iterateFromId}&Comment=resume for cloned progression stage ${iterateFromId}&OperationReason=CloneResumeProgressionStage&skipToOriginalRunningStage=false&registerAnalysis=${registerAnalysis.toString()}&ignorePlanAllocationHistory=${ignoreHistoricalAllocation}`;
      }
      return yield this._post({}, address);
    });
  }
  stopExperiment(id) {
    return __async(this, null, function* () {
      const address = `/${id}/stop`;
      return yield this._post({}, address);
    });
  }
  advanceExperiment(id, registerAnalysis = false) {
    return __async(this, null, function* () {
      const address = `/${id}/advance?registerAnalysis=${registerAnalysis.toString()}`;
      return yield this._post({}, address);
    });
  }
  deleteExperiment(id) {
    return __async(this, null, function* () {
      const address = `/${id}`;
      return yield this._delete(address);
    });
  }
  unhideExperiment(id) {
    return __async(this, null, function* () {
      const address = `/${id}?hidden=false`;
      return yield this._put({}, address);
    });
  }
  getExperiment(id) {
    return __async(this, null, function* () {
      const address = `/${id}?loadAnalyses=true`;
      const result = yield this._get(address);
      return result;
    });
  }
  getPrototypeExperiment(template, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const address = `/prototype?template=${template}&managementGroup=${managementGroup}&workspaceId=${workspaceId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getScorecardsForFeature(featureId) {
    return __async(this, null, function* () {
      const address = `/scorecards/feature/${featureId}`;
      return yield this._get(address);
    });
  }
  getRelatedExperiments(experimentId) {
    return __async(this, null, function* () {
      const address = `/${experimentId}/related?loadAnalyses=true`;
      const result = yield this._get(address);
      return result;
    });
  }
  getOperationChecksForExperiment(experimentId) {
    return __async(this, null, function* () {
      const address = `/${experimentId}/operations`;
      const result = yield this._get(address);
      return result;
    });
  }
  getAdvanceExperimentEffect(id) {
    return __async(this, null, function* () {
      const address = `/${id}/advance`;
      const result = yield this._get(address);
      return result;
    });
  }
  getExperimentJournals(experimentId) {
    return __async(this, null, function* () {
      const address = `/${experimentId}/journal`;
      const result = yield this._get(address);
      return result;
    });
  }
  getExperimentScorecards(experimentId) {
    return __async(this, null, function* () {
      const address = `/${experimentId}/scorecards?primaryOnly=false`;
      const result = yield this._get(address);
      return result;
    });
  }
  getExperimentEditRules(experimentId) {
    return __async(this, null, function* () {
      const address = `/${experimentId}/edit`;
      const result = yield this._get(address);
      return result;
    });
  }
  getAllExperiments(address) {
    return __async(this, null, function* () {
      const result = yield this._get(address);
      return result;
    });
  }
  scorecardData(ids) {
    return __async(this, null, function* () {
      const address = "/scorecards/search";
      const result = yield this._post(ids, address);
      return result;
    });
  }
  updateExperiment(experimentId, update) {
    return __async(this, null, function* () {
      const address = `/${experimentId}`;
      return yield this._patch(update, address);
    });
  }
  createExperiment(templateName, data) {
    return __async(this, null, function* () {
      const address = `/new?template=${templateName}`;
      const result = yield this._post(data, address);
      return result;
    });
  }
  getExperimentTASDeploymentPercentage(stepId) {
    return __async(this, null, function* () {
      const address = `/steps/${stepId}/tasDeploymentStatus`;
      const result = yield this._get(address);
      return result;
    });
  }
}
__decorateClass([
  onError({ message: `An error occurred while starting the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "startExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while cloning the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "cloneExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while resuming the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "crossIterationResume", 1);
__decorateClass([
  onError({ message: `An error occurred while stopping the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "stopExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while advancing the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "advanceExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while deleting the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "deleteExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while unhiding the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "unhideExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while getting the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while getting the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getPrototypeExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while getting scorecards for the feature. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getScorecardsForFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while getting related experiments for the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getRelatedExperiments", 1);
__decorateClass([
  onError({ message: `An error occurred while getting operation checks for the feature. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getOperationChecksForExperiment", 1);
__decorateClass([
  onError({ message: `An error occurred while retrieving advance effects of the experiment. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getAdvanceExperimentEffect", 1);
__decorateClass([
  onError({ message: `Failed to fetch progression stage history. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getExperimentJournals", 1);
__decorateClass([
  onError({ message: `Failed to fetch experiment scorecards. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getExperimentScorecards", 1);
__decorateClass([
  onError({ message: `Failed to fetch experiment edit validation rules. ${continuationErrorMessage}` })
], ExperimentResourcesBase.prototype, "getExperimentEditRules", 1);
__decorateClass([
  onError({ message: "Failed to fetch all experiments" })
], ExperimentResourcesBase.prototype, "getAllExperiments", 1);
__decorateClass([
  onError({ message: "Failed to update the experiment." })
], ExperimentResourcesBase.prototype, "updateExperiment", 1);
__decorateClass([
  onError({ message: "Failed to create the experiment." })
], ExperimentResourcesBase.prototype, "createExperiment", 1);
export {
  ExperimentResourcesBase
};
//# sourceMappingURL=ExperimentResourcesBase.js.map
